import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthService} from '../../core/auth.service';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'pdf-viewer',
  templateUrl: './pdf-viewer.component.html',
  styleUrls: ['./pdf-viewer.component.scss']
})
export class PdfViewerComponent implements OnInit {

  errorMessage: string;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authServ: AuthService,
    private translate: TranslateService,
  ) { }

  ngOnInit() {}

}



// WEBPACK FOOTER //
// ./src/app/main/pdf-viewer/pdf-viewer.component.ts